import { LocationApi } from '@/apis';
import RootStore from '.';
import BaseStore from './BaseStore';
import { flow, makeObservable, observable } from 'mobx';
import { ResponseData } from '@/types/http';
import { TableState } from '@tanstack/react-table';
import { GetLocationsByBikeResponse, GetLocationsRequest, GetLocationsResponse, GetPriceComboboxResponse, PriceCombobox } from '@/types/http-payload/location';
import { Location } from '@/types/location';

export default class LocationStore extends BaseStore {
    locations: Location[] = [];
    location: any;

    prices: PriceCombobox[] = [];

    api: LocationApi;

    totalPage: number = 0;
    // for bike
    reloadTrigger: number = 0;
    locationBikes: Location[] = [];
    totalRecordRegister: number = 0;
    pagingRegister: TableState = { ...this.defaultPaging };

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            locations: observable,
            location: observable,
            locationBikes: observable,
            totalRecordRegister: observable,
            pagingRegister: observable,
            reloadTrigger: observable,
            prices: observable,
            getLocations: flow.bound,
            getLocationById: flow.bound,
            createLocation: flow.bound,
            editLocation: flow.bound,
            deleteLocation: flow.bound,
            getLocationsByBike: flow.bound,
            getPricesCombobox: flow.bound
        });
        this.api = new LocationApi();
    }

    *getLocations(searchParams?: GetLocationsRequest, paging?: TableState) {
        try {
            const payload = { ...this.convertPagingFromTableToRequest(paging ?? this.paging), ...searchParams };
            const res: ResponseData<GetLocationsResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getLocations, payload);
            if (res.ok) {
                this.locations = res.data.elements;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.paginate)
                };
                this.totalRecord = res.data.paginate.totalRecord;
                this.totalPage = res.data.paginate.totalPage;
            }
        } catch (error) {
        }
    }

    *getLocationById(idLocation: string | number) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getLocationById, idLocation);
            if (res.ok) {
                this.location = res.data;
                return res;
            }
            return false;
        } catch (error) {
        }
    }

    *createLocation(payload) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.createLocation, payload);
            if (res.ok) {
                this.location = res.data;
                return res;
            }
        } catch (error) {
        }
    }

    *editLocation(locationId: number | string, payload) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.editLocation, { locationId, payload });
            if (res.ok) {
                this.location = res.data;
                return res;
            }
        } catch (error) {
        }
    }

    *deleteLocation(locationId: number) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.deleteLocation, locationId);
            if (res.ok) {
                return res;
            }
        } catch (error) {
        }
    }

    // for bike
    *getLocationsByBike(searchParams: any, paging?: TableState) {
        try {
            const payload = { ...this.convertPagingFromTableToRequest(paging ?? this.pagingRegister), ...searchParams };
            const res: ResponseData<GetLocationsByBikeResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getLocationsByBike, payload);
            if (res.ok) {
                this.locationBikes = res.data.elements;
                this.pagingRegister = {
                    ...this.pagingRegister,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.paginate)
                };
                this.totalRecordRegister = res.data.paginate.totalRecord;
            }
        } catch (error) {
        }
    }

    *getPricesCombobox() {
        try {
            const payload = { size: 10, page: -1 };
            const res: ResponseData<GetPriceComboboxResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getPricesCombobox, payload);
            if (res.ok) {
                this.prices = res.data.elements;
                return true;
            }
            return false;
        } catch (error) {
        }
    }

    clean(): void {
        super.clean();

        this.locations = [];
        this.locationBikes = [];

        this.totalRecordRegister = 0;
        this.pagingRegister = { ...this.defaultPaging };
        this.reloadTrigger = 0;
    }
}
